import { create } from 'zustand';
import type { RelanceOnboardingStatus } from '../types/onboarding';

interface OnboardingState {
    /** Drives the full-screen walkthrough overlay in RootLayout — true only while status is NotStarted. */
    onboardingRequired: boolean;
    /**
     * False until useOnboardingGate's status fetch has settled (succeeded or failed). Defaulting
     * `onboardingRequired` to false so it looks the same as "resolved, not required" is what let
     * RootLayout render Home/InitialSync for one paint before the fetch came back — this flag lets
     * RootLayout tell "not required" apart from "not known yet" and keep showing the loading state
     * for the latter, the same way it already does for the auth guard's own `ready`.
     */
    onboardingResolved: boolean;
    status: RelanceOnboardingStatus | null;
    /** Whether this user may accept for the company — decides how far their walkthrough goes. */
    isAdministrator: boolean;
    /** Whether this user has already been welcomed — decides whether the walkthrough starts at all. */
    hasSeenWelcome: boolean;
    setOnboardingRequired: (v: boolean) => void;
    setOnboardingResolved: (v: boolean) => void;
    setStatus: (v: RelanceOnboardingStatus | null) => void;
    setIsAdministrator: (v: boolean) => void;
    setHasSeenWelcome: (v: boolean) => void;
}

export const useOnboardingStore = create<OnboardingState>((set) => ({
    onboardingRequired: false,
    onboardingResolved: false,
    status: null,
    isAdministrator: false,
    hasSeenWelcome: false,
    setOnboardingRequired: (onboardingRequired) => set({ onboardingRequired }),
    setOnboardingResolved: (onboardingResolved) => set({ onboardingResolved }),
    setStatus: (status) => set({ status }),
    setIsAdministrator: (isAdministrator) => set({ isAdministrator }),
    setHasSeenWelcome: (hasSeenWelcome) => set({ hasSeenWelcome }),
}));
